import { createContext, useEffect, useState } from "react";
import { Link as ScrollLink } from "react-scroll";

export const ThemeContext = createContext(null);

export default function Headers(props) {
  const { onThemeChange, theme } = props;

  const toggleTheme = () => {
    const switchBtn = document.getElementById("switchBtn");
    if (switchBtn?.checked) {
      onThemeChange("dark");
      localStorage.setItem("Dark_Mode", JSON.stringify("dark"));
    } else {
      onThemeChange("light");
      localStorage.setItem("Dark_Mode", JSON.stringify("light"));
    }
  };

  useEffect(() => {
    var datax = window.localStorage.getItem("chechkbox");
    if (datax !== null) {
      const trueCheck = document.getElementById("switchBtn");
      trueCheck.checked = datax;
    }
  }, []);

  useEffect(() => {
    const trueCheckx = document.getElementById("switchBtn");
    trueCheckx?.addEventListener("click", () => {
      if (trueCheckx.checked) {
        localStorage.setItem("chechkbox", trueCheckx?.value);
      } else {
        localStorage.removeItem("chechkbox");
      }
    });
  }, []);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const header = document.querySelector("header");
      if (window.scrollY > 100) {
        header?.classList.add("active");
      } else {
        header?.classList.remove("active");
      }
    });
  }, []);

  const showMenuMobile = () => {
    const hamburger = document.querySelector("#hamburger");
    const navMenu = document.querySelector("#navMenu");

    hamburger?.classList.toggle("hamburger-active");
    navMenu?.classList.toggle("hidden");
  };

  const closeMenu = () => {
    const navigateMenu = document.querySelector("#navMenu");
    const hamburger = document.querySelector("#hamburger");

    navigateMenu?.classList.toggle("hidden");
    hamburger?.classList.toggle("hamburger-active");
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <header className="navbar">
        <div className="w-full xl:w-[90%] m-auto p-2 ">
          <div className="relative">
            <div className="flex justify-around lg:justify-between items-center relative">
              <button
                id="hamburger"
                name="hamburger"
                type="button"
                className="block relative left-0 lg:hidden order-1 lg:order-0 z-[99999]"
                onClick={showMenuMobile}
              >
                <span className="hamburger-line transition duration-300 ease-in-out origin-top-left"></span>

                <span className="hamburger-line transition duration-300 ease-in-out"></span>

                <span className="hamburger-line transition duration-300 ease-in-out origin-bottom-left"></span>
              </button>

              <div className="flex justify-center items-center w-auto cursor-pointer">
                <a href={"/"}>
                  <img
                    src="https://res.cloudinary.com/datadriven/image/upload/v1623300735/Wordpress%20Alcott/Alcott_Logo_01_White_1.png"
                    alt=""
                    className="w-[200px] lg:w-[222px] h-[auto]"
                  />
                </a>
              </div>

              <div className="flex items-center lg:px-4">
                <nav id="navMenu" className="hidden HeaderNav addBg">
                  <ul className="block p-10 lg:p-0 lg:flex text-center items-center">
                    <li
                      key={"h1"}
                      className={"mHeader link home link-active"}
                      onClick={closeMenu}
                    >
                      <a href={"/#home"}>
                        <p>Home</p>
                      </a>
                    </li>

                    <li
                      key={"h3"}
                      className={"mHeader link about"}
                      onClick={closeMenu}
                    >
                      <ScrollLink
                        duration={100}
                        className="cursor-pointer"
                        to="about"
                        smooth={true}
                      >
                        <p>About Us</p>
                      </ScrollLink>
                    </li>

                    <li
                      key={"h3"}
                      className={"mHeader link services"}
                      onClick={closeMenu}
                    >
                      <ScrollLink
                        duration={100}
                        className="cursor-pointer"
                        to="services"
                        smooth={true}
                      >
                        <p>Services</p>
                      </ScrollLink>
                    </li>

                    <li
                      key={"h4"}
                      className={"mHeader link project"}
                      onClick={closeMenu}
                    >
                      <ScrollLink
                        duration={100}
                        className="cursor-pointer"
                        to="project"
                        smooth={true}
                      >
                        <p>Project</p>
                      </ScrollLink>
                    </li>

                    <li
                      key={"h5"}
                      className={"mHeader link team"}
                      onClick={closeMenu}
                    >
                      <ScrollLink
                        duration={100}
                        className="cursor-pointer"
                        to="team"
                        smooth={true}
                      >
                        <p>Team</p>
                      </ScrollLink>
                    </li>

                    <li
                      key={"h5"}
                      className={"mHeader link contact"}
                      onClick={closeMenu}
                    >
                      <ScrollLink
                        duration={100}
                        className="cursor-pointer"
                        to="contact"
                        smooth={true}
                      >
                        Contact Us
                      </ScrollLink>
                    </li>

                    <div className="flex justify-center items-center relative mt-5 lg:mt-0">
                      <input
                        id="switchBtn"
                        type="checkbox"
                        value="1"
                        className="hidden"
                        onChange={toggleTheme}
                      ></input>

                      <label
                        htmlFor="switchBtn"
                        className="flex justify-center items-center cursor-pointer"
                      >
                        <div className="w-6 h-2 bg-LintasanDM rounded-full flex items-center">
                          <div className="w-4 h-4 bg-DotDM rounded-full toggle-circle"></div>
                        </div>
                      </label>

                      <span id="spanMode" className="mHeader ml-2 text-[20px] ">
                        {theme === "light" ? "Light" : "Dark"}
                      </span>
                    </div>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    </ThemeContext.Provider>
  );
}
